import React from 'react'
import classnames from 'classnames'

const PaperCheckSVG = ({ className }) => {
  return (
    <svg
      viewBox="0 0 24 32"
      className={classnames('dealmed-icon', className)}
      aria-hidden={true}
      focusable={false}
    >
      <path d="M23.121 6.121l-5.243-5.243c-0.485-0.485-1.435-0.879-2.121-0.879h-12.757c-1.657 0-3 1.343-3 3v26c0 1.657 1.343 3 3 3h18c1.657 0 3-1.343 3-3v-20.757c0-0.686-0.394-1.636-0.879-2.121zM21.707 7.536c0.108 0.108 0.226 0.316 0.262 0.464h-5.969v-5.969c0.148 0.037 0.356 0.154 0.464 0.262l5.243 5.243zM21 30h-18c-0.552 0-1-0.448-1-1v-26c0-0.552 0.448-1 1-1h11v6.5c0 0.828 0.672 1.5 1.5 1.5h6.5v19c0 0.552-0.448 1-1 1zM18.846 16.816c0.294-0.292 0.296-0.767 0.004-1.061l-0.529-0.533c-0.292-0.294-0.767-0.296-1.062-0.004l-7.361 7.302-3.153-3.162c-0.293-0.293-0.768-0.294-1.061-0.001l-0.532 0.53c-0.294 0.293-0.294 0.768-0.002 1.062l4.21 4.222c0.292 0.293 0.766 0.294 1.060 0.003l8.424-8.357z"></path>
    </svg>
  )
}

export default PaperCheckSVG
